export const MODULE_PERMISSIONS = [
  // =========================================================
  // USER PAGE PERMISSIONS
  // =========================================================

  {
    group: "User Page Permissions",
    key: "dashboard",
    label: "Dashboard",
    actions: ["view"],
  },
{
  group: "User Page Permissions",
  key: "notes",
  label: "Notes",
  actions: ["view", "create", "edit", "delete", "share"],
},
  {
    group: "User Page Permissions",
    key: "timesheet",
    label: "Timesheet",
    actions: ["view", "create", "edit", "delete"],
  },

  {
    group: "User Page Permissions",
    key: "employeeLog",
    label: "Employee Logs",
    actions: ["view", "viewAll"],
  },

  {
    group: "User Page Permissions",
    key: "employeeDrawingReport",
    label: "Employee Drawing Report",
    actions: ["view", "viewAll", "exportExcel"],
  },

  {
    group: "User Page Permissions",
    key: "employeeReview",
    label: "Employee Review",
    actions: ["view", "create", "edit"],
  },

  {
    group: "User Page Permissions",
    key: "leaveApplication",
    label: "Leave Application & Management",
    actions: ["view", "create", "approve", "delete"],
  },

  {
    group: "User Page Permissions",
    key: "manageEmployees",
    label: "Manage Employee",
    actions: ["view", "create", "edit", "delete"],
  },

 {
  group: "User Page Permissions",
  key: "rolePermissions",
  label: "Role & Permission",
  actions: ["view", "create", "edit"],
},
{
  group: "User Page Permissions",
  key: "projectHoursSummary",
  label: "Project-wise Hours Summary",
  actions: ["view", "exportExcel"],
},
  // =========================================================
  // MAIL PERMISSIONS
  // =========================================================

  {
    group: "Mail Permissions",
    key: "email",
    label: "Email",
    actions: ["view"],
  },

  {
    group: "Mail Permissions",
    key: "createMailAccount",
    label: "Create Mail Account",
    actions: ["view"],
  },

  // =========================================================
  // PROJECT PERMISSIONS
  // =========================================================

  {
    group: "Project Permissions",
    key: "addProject",
    label: "Add Project",
    actions: [
      "view",
      "create",
      "USA",
      "CANADA",
      "ArchInd",
      "Gruda",
      "DC",
      "ProjectData",
      "Interior",
      "BDM",
      "Finance",
    ],
  },

  {
    group: "Project Permissions",
    key: "transmittal",
    label: "Transmittal",
    actions: ["view", "create", "edit", "delete", "exportPdf"],
  },

  {
    group: "Project Permissions",
    key: "checklist",
    label: "Checklist",
    actions: ["view", "create", "edit", "delete"],
  },

  {
    group: "Project Permissions",
    key: "architect",
    label: "Architect",
    actions: ["constructionReport"],
  },

  // =========================================================
  // MESSENGER PERMISSIONS
  // =========================================================

  {
    group: "Messenger Permissions",
    key: "messengerUser",
    label: "User Message",
    actions: ["view", "create", "delete"],
  },

  {
    group: "Messenger Permissions",
    key: "messengerProject",
    label: "Project-wise",
    actions: ["view", "create", "delete"],
  },

  {
    group: "Messenger Permissions",
    key: "messengerCategory",
    label: "Category-wise",
    actions: ["view", "create", "delete"],
  },

  // =========================================================
  // HIRING MANAGEMENT PERMISSIONS
  // =========================================================

  {
    group: "Hiring Management Permissions",
    key: "hiringDashboard",
    label: "Hiring Dashboard",
    actions: ["view"],
  },

  {
    group: "Hiring Management Permissions",
    key: "jobOpenings",
    label: "Job Openings",
    actions: ["view", "create", "edit", "delete"],
  },

  {
    group: "Hiring Management Permissions",
    key: "candidates",
    label: "Candidates",
    actions: ["view", "create", "edit", "delete"],
  },

  {
    group: "Hiring Management Permissions",
    key: "interviews",
    label: "Interviews",
    actions: ["view", "create", "edit", "delete"],
  },

  {
    group: "Hiring Management Permissions",
    key: "offers",
    label: "Offers",
    actions: ["view", "create", "edit", "delete", "sendMail"],
  },

  {
    group: "Hiring Management Permissions",
    key: "joining",
    label: "Upcoming Joinings",
    actions: ["view", "create", "edit", "delete"],
  },

  {
    group: "Hiring Management Permissions",
    key: "closedHiring",
    label: "Closed Hiring",
    actions: ["view"],
  },

  {
    group: "Hiring Management Permissions",
    key: "recruitmentReports",
    label: "Recruitment Reports",
    actions: ["view", "exportExcel"],
  },

  // =========================================================
  // CRM PERMISSIONS
  // =========================================================

  {
    group: "CRM Permissions",
    key: "crmDashboard",
    label: "CRM Dashboard",
    actions: ["view"],
  },

  {
    group: "CRM Permissions",
    key: "leads",
    label: "Leads",
    actions: ["view", "create", "edit", "delete"],
  },

  {
    group: "CRM Permissions",
    key: "proposals",
    label: "Proposals",
    actions: ["view", "create", "edit", "delete"],
  },

  {
    group: "CRM Permissions",
    key: "sentEmails",
    label: "Sent Emails",
    actions: ["viewIntro", "viewPortfolio", "viewProposal"],
  },

  {
    group: "CRM Permissions",
    key: "wonLeads",
    label: "Won Leads",
    actions: ["view"],
  },

  {
    group: "CRM Permissions",
    key: "lostLeads",
    label: "Lost Leads",
    actions: ["view"],
  },

  {
    group: "CRM Permissions",
    key: "crmReports",
    label: "CRM Reports",
    actions: ["view", "exportExcel"],
  },

  // =========================================================
  // FINANCE PERMISSIONS
  // =========================================================

  {
    group: "Finance Permissions",
    key: "financeDashboard",
    label: "Finance Dashboard",
    actions: ["view"],
  },

  {
    group: "Finance Permissions",
    key: "companyExpenses",
    label: "Company Expenses",
    actions: ["view", "viewAll", "exportExcel"],
  },
    {
    group: "Finance Permissions",
    key: "financeEntry",
    label: "Finance Entry",
    actions: ["view", "create", "edit", "delete"],
  },

  {
    group: "Finance Permissions",
    key: "gstReports",
    label: "GST Reports",
    actions: ["view", "exportExcel"],
  },

  {
    group: "Finance Permissions",
    key: "tdsReceivable",
    label: "TDS Receivable",
    actions: ["view", "exportExcel"],
  },

  {
    group: "Finance Permissions",
    key: "tdsPayment",
    label: "TDS Payment",
    actions: ["view", "exportExcel"],
  },
  // =========================================================
  // SALES PERMISSIONS
  // =========================================================

  {
    group: "Sales Permissions",
    key: "salesDashboard",
    label: "Sales Dashboard",
    actions: ["view"],
  },

  {
    group: "Sales Permissions",
    key: "serviceMaster",
    label: "Service Master",
    actions: ["view", "create", "edit", "delete"],
  },

  {
    group: "Sales Permissions",
    key: "clientMaster",
    label: "Client Master",
    actions: ["view", "create", "edit", "delete"],
  },

  {
    group: "Sales Permissions",
    key: "bankMaster",
    label: "Bank Detail Master",
    actions: ["view", "create", "edit", "delete"],
  },

  {
    group: "Sales Permissions",
    key: "termsMaster",
    label: "Terms & Conditions",
    actions: ["view", "create", "edit", "delete"],
  },

  {
    group: "Sales Permissions",
    key: "quotations",
    label: "Quotations",
    actions: [
      "view",
      "create",
      "edit",
      "delete",
      "exportPdf",
      "sendMail",
      "convertToPI",
    ],
  },

  {
    group: "Sales Permissions",
    key: "proformaInvoices",
    label: "Proforma Invoices",
    actions: [
      "view",
      "create",
      "edit",
      "delete",
      "exportPdf",
      "sendMail",
      "convertToInvoice",
    ],
  },

  {
    group: "Sales Permissions",
    key: "invoices",
    label: "Invoices",
    actions: [
      "view",
      "create",
      "edit",
      "delete",
      "exportPdf",
      "sendMail",
      "recordPayment",
    ],
  },
  // =========================================================
  // ASSETS PERMISSIONS
  // =========================================================

  {
    group: "Assets Permissions",
    key: "assets",
    label: "Assets",
    actions: ["view"],
  },

  {
    group: "Assets Permissions",
    key: "softwareEmployee",
    label: "My Software",
    actions: ["view"],
  },

  {
    group: "Assets Permissions",
    key: "hardwareEmployee",
    label: "My Hardware",
    actions: ["view"],
  },

  {
    group: "Assets Permissions",
    key: "softwareAllStaff",
    label: "Software All Staff",
    actions: ["view", "create", "edit", "delete"],
  },

  {
    group: "Assets Permissions",
    key: "hardwareAllStaff",
    label: "Hardware All Staff",
    actions: ["view", "create", "edit", "delete"],
  },
];

// =========================================================
// ACTION LABELS
// =========================================================

export const ACTION_LABELS = {
  view: "View",
  create: "Create",
  edit: "Edit",
  delete: "Delete",
  approve: "Approve",
  exportExcel: "Export Excel",
  exportPdf: "Export PDF",
  sendMail: "Send Mail",
  viewAll: "View All",
  share: "Share",

  USA: "USA",
  CANADA: "CANADA",
  ArchInd: "Arch.ind",
  Gruda: "Gruda",
  DC: "DC",
  ProjectData: "Project Data",
  Interior: "Interior",
  BDM: "BD & M",
  Finance: "Finance",

  constructionReport: "Construction Report",

  viewIntro: "Intro Mail",
  viewPortfolio: "Portfolio Mail",
  viewProposal: "Proposal Mail",

    convertToPI: "Convert to Proforma Invoice",
  convertToInvoice: "Convert to Invoice",
  recordPayment: "Record Payment",
};

// =========================================================
// GROUP DISPLAY CONFIGURATION
// RolePermissionPage me isi order me groups render honge.
// =========================================================

export const GROUP_META = {
  "User Page Permissions": {
    icon: "👤",
    label: "User Page Permissions",
  },

  "Mail Permissions": {
    icon: "✉️",
    label: "Mail Permissions",
  },

  "Project Permissions": {
    icon: "🏗️",
    label: "Project Permissions",
  },

  "Messenger Permissions": {
    icon: "💬",
    label: "Messenger Permissions",
  },

  "Hiring Management Permissions": {
    icon: "🧑‍💼",
    label: "Hiring Management Permissions",
  },

  "CRM Permissions": {
    icon: "📈",
    label: "CRM Permissions",
  },

  "Finance Permissions": {
    icon: "💰",
    label: "Finance Permissions",
  },
  "Sales Permissions": {
    icon: "💼",
    label: "Sales Permissions",
  },
  "Assets Permissions": {
    icon: "💻",
    label: "Assets Permissions",
  },
};